import(/* webpackMode: "eager" */ "/data/web/oneroof-rebuild/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/data/web/oneroof-rebuild/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(other)/(premiumProperty)/_modules/content.js");
